export const Plans = {
  ANNUAL: 'fffvipa',
  SEASONAL: 'fffvip',
  TRIAL: 'ffftrial',
  SOCIAL: 'fffsocial',
};

export const PlansLiteral = {
  ANNUAL: 'select',
  SEASONAL: 'seasonal',
  TRIAL: 'trial',
};

export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';

export const couponScreenKey = {
  UPGRADE: 'upgrade',
  REACTIVATE_EXPIRED_SUBSCRIPTION: 'reactivate-expired-subscription',
};

export const annualCoupons = ['freeforyou', 'firstfree', 'yesfreebie', 'yayme'];
